export const HAMPER_DISCOUNT = {
  BlossomDelight: 0.03,   // 3%
  CharmingBloom: 0.04,    // 4%
  VIPOpulence: 0.05       // 5%
};